import axios_instance from './liveChatAxiosInst';

async function getActiveCom(
        state,
        chatId,
        dispatch,
    ) {
    await axios_instance.post(
        process.env.REACT_APP_LIVE_CHAT_API,
        {
            action: "readActiveCom",
            operator_id: state.current_operator_id,
            chat_id: chatId,
            limit: state.com_offset,
            pseudo: state.pseudo,
        },
    )
    .then((resp) => {
        if (resp.status === 200) { // console.log('getActiveCom => activeCom : ', resp.data)
            dispatch({
                type: 'change_active_communication',
                payload: {active_communication: resp.data.activeCom}
            });
        } else {
            dispatch({
                type: 'change_active_communication',
                payload: {active_communication: []}
            });
        }
    })
    .catch (() => 
        dispatch({
            type: 'change_active_communication',
            payload: {active_communication: []}
        })
    );
}

export default getActiveCom;